<script setup lang="ts">
import { type PropType } from "vue";
import type { UIColor } from "../../..";

defineProps({
  /*
      Border color
      values: see src/css/color.css
    */
  color: {
    type: String as PropType<UIColor>,
    required: true,
  },

  /*
      Border width
    */
  borderWidth: {
    type: Number,
    required: true,
  },

  /*
      Border width
      values: dotted, dashed, solid, double
    */
  borderStyle: {
    type: String as PropType<"dotted" | "dashed" | "solid" | "double">,
    required: true,
  },
});
</script>

<template>
  <div
    :class="$style.container"
    :style="{
      'border-color': `var(${color})`,
      'border-width': `${borderWidth}px`,
      'border-style': borderStyle,
    }"
  />
</template>

<style module>
.container {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  border: solid 1px transparent;
}
</style>
